import rpcClient from './RpcClient';
import { getCombinedGridLayoutByIdRpc, updateGridLayoutFromCombinedModelRpc, getCombinedGridLayoutByDndAreaNameRpc, createGridLayoutFromCombinedModelRpc, getCombinedGridLayoutsForObjectIdRpc } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
export function fetchGridLayoutById(id) {
  return rpcClient.call(getCombinedGridLayoutByIdRpc, {
    request: {
      id
    }
  });
}
export function fetchGridLayoutByDndAreaName(contentId, dndAreaName) {
  return rpcClient.call(getCombinedGridLayoutByDndAreaNameRpc, {
    request: {
      objectId: contentId,
      dndAreaName
    }
  });
}
export function updateGridLayout(gridLayoutId, gridLayout) {
  // TODO: Multiple "ids" for a grid layout, maybe change this to update by content id + dndAreaName?
  return rpcClient.call(updateGridLayoutFromCombinedModelRpc, {
    request: {
      id: gridLayoutId,
      gridLayout
    }
  });
}
export function createGridLayout(contentId, gridLayout) {
  return rpcClient.call(createGridLayoutFromCombinedModelRpc, {
    request: {
      objectId: contentId,
      gridLayout
    }
  });
}
export function fetchGridLayoutsForContentId(contentId) {
  return rpcClient.call(getCombinedGridLayoutsForObjectIdRpc, {
    request: {
      objectId: contentId
    }
  });
}